enum Geo {
  NA = 'na',
  EMEA = 'emea',
  GC = 'gc',
  APLA = 'apla',
}

export default Geo;
